import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { AppState, MainAppState } from "./models";

export const appStateSelector = createDraftSafeSelector(
  (state: MainAppState) => state,
  (state: MainAppState) => state.app.appState,
);

export const userPreferredLanguageSelector = createDraftSafeSelector(
  appStateSelector,
  (state: AppState) => state.preferredLanguage,
);

export const userRolesPermissionsSelector = createDraftSafeSelector(
  appStateSelector,
  (state: AppState) => state.rolesAndPermissions,
);

export const loaderSelector = createDraftSafeSelector(
  appStateSelector,
  (state: AppState) => state.loader,
);

export const sidebarSelector = createDraftSafeSelector(
  appStateSelector,
  (state: AppState) => state.sidebar,
);

export const fullSidebarSelector = createDraftSafeSelector(
  appStateSelector,
  (state: AppState) => state.fullSidebar,
);

export const toastSelector = createDraftSafeSelector(
  appStateSelector,
  (state: AppState) => state.toast,
);

export const SiteCoreContentSelector = createDraftSafeSelector(
  appStateSelector,
  (state: AppState) => state.siteCorePageContent,
);

export const siteCoreContentLoadingSelector = createDraftSafeSelector(
  appStateSelector,
  (state: AppState) => state.siteCorePageContentLoading,
);

//for navigation site core - (left,right,header,footer data)
export const navigationSiteCoreContentSelector = createDraftSafeSelector(
  appStateSelector,
  (state: AppState) => state.navigationSiteCorePageContent,
);

export const isDataModifiedCurrentPageSelector = createDraftSafeSelector(
  appStateSelector,
  (state: AppState) => state.isDataModifiedCurrentPage,
);

export const navigationDataSelector = createDraftSafeSelector(
  appStateSelector,
  (state: AppState) => state.navigationData,
);

export const currencyListSelector = createDraftSafeSelector(
  appStateSelector,
  (state: AppState) => state.currencyList,
);
